export const ClientIcon = () => {
  return (
    <svg width="57" height="66" viewBox="0 0 57 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.7">
        <path
          d="M56.25 56V60.875C56.25 61.0821 56.0821 61.25 55.875 61.25H34.125C33.9179 61.25 33.75 61.0821 33.75 60.875V56C33.75 49.7868 38.7868 44.75 45 44.75C51.2132 44.75 56.25 49.7868 56.25 56Z"
          fill="#66CD58"
          stroke="#252525"
          stroke-width="1.5"
        />
        <circle cx="44.5" cy="40.5" r="6.75" fill="#ADD7A7" stroke="#252525" stroke-width="1.5" />
        <path
          d="M23.25 56V60.875C23.25 61.0821 23.0821 61.25 22.875 61.25H1.125C0.917893 61.25 0.75 61.0821 0.75 60.875V56C0.75 49.7868 5.7868 44.75 12 44.75C18.2132 44.75 23.25 49.7868 23.25 56Z"
          fill="#8FD784"
          stroke="#252525"
          stroke-width="1.5"
        />
        <circle cx="11.5" cy="40.5" r="6.75" fill="#ADD7A7" stroke="#252525" stroke-width="1.5" />
        <path
          d="M39.25 60V64.875C39.25 65.0821 39.0821 65.25 38.875 65.25H17.125C16.9179 65.25 16.75 65.0821 16.75 64.875V60C16.75 53.7868 21.7868 48.75 28 48.75C34.2132 48.75 39.25 53.7868 39.25 60Z"
          fill="#50B842"
          stroke="#252525"
          stroke-width="1.5"
        />
        <circle cx="27.5" cy="44.5" r="6.75" fill="#ADD7A7" stroke="#252525" stroke-width="1.5" />
        <circle cx="28.5" cy="19.5" r="13.75" fill="#78DF6A" stroke="#252525" stroke-width="1.5" />
        <circle cx="28" cy="19" r="8.25" fill="#E6FFE3" stroke="#252525" stroke-width="1.5" />
        <circle cx="28" cy="19" r="3.25" fill="#78DF6A" stroke="#252525" stroke-width="1.5" />
        <path
          d="M18.5 5.58907V10H13.5828C13.5298 10 13.4789 9.97893 13.4414 9.94142L9.34142 5.84142C9.21543 5.71543 9.30466 5.5 9.48284 5.5H13.3C13.4105 5.5 13.5 5.41046 13.5 5.3V1.44907C13.5 1.27592 13.7051 1.18458 13.8338 1.30041L18.4338 5.44041C18.4759 5.47834 18.5 5.53238 18.5 5.58907Z"
          fill="#66CD58"
        />
        <path
          d="M25.5 17.5L18.5 10M18.5 10V5.58907C18.5 5.53238 18.4759 5.47834 18.4338 5.44041L13.8338 1.30041C13.7051 1.18458 13.5 1.27592 13.5 1.44907V5.3C13.5 5.41046 13.4105 5.5 13.3 5.5H9.48284C9.30466 5.5 9.21543 5.71543 9.34142 5.84142L13.4414 9.94142C13.4789 9.97893 13.5298 10 13.5828 10H18.5Z"
          stroke="#252525"
          stroke-width="1.5"
        />
      </g>
    </svg>
  );
};
